import { buildResult, pass, skip } from "../../buildResult";
import { defineTest } from "../../defineTest";
import { CHATGPT_LAMBDA, getEndedIngestLambdas, resolveTrace } from "../../helper/trace";

export default defineTest(
  "trace_chatgpt_completed",
  "ChatGPT summarization completed",
  ({ trace, fetchErrors }) => {
    const resolved = resolveTrace({ trace, fetchErrors });
    if (!resolved.ok) return resolved.result;

    const { events } = resolved;
    if (events.length === 0) return skip("Trace has no events");

    const endedIngest = getEndedIngestLambdas(events);
    const chatgptEnds = events.filter(
      (e) => e.lambda_name === CHATGPT_LAMBDA && e.status === "END"
    ).length;

    if (chatgptEnds > 0) {
      return pass("RunChatgptFunction completed");
    }

    if (endedIngest.length > 0) {
      return buildResult({
        warnings: ["RunChatgptFunction has no END event (summarization may be incomplete)"],
      });
    }

    return skip("No ChatGPT or audio ingest events to evaluate");
  }
);
